export const PROTOCOLS = ['yearn', 'stakewise']
